import React from 'react';

import { type ContentCardData, ContentCardGroup, type GroupData } from '@af/design-system-docs-ui';

import OverviewPage from '../../templates/overview-page';

import heroDark from './_assets/hero.dark.png';
import heroLight from './_assets/hero.light.png';

const data: GroupData<ContentCardData>[] = [
	{
		title: 'Design tokens',
		cards: [
			{
				title: 'Tokens',
				description:
					'Design tokens are the single source of truth to name and store decisions about the user interface.',
				href: '/foundations/tokens',
				icon: 'tokens',
			},
		],
	},
	{
		title: 'Guidelines',
		cards: [
			{
				title: 'Accessibility',
				description:
					'Accessible design enables people of all abilities interact with, understand, and navigate our products.',
				href: '/foundations/accessibility',
				icon: 'accessibility',
			},
			{
				title: 'Content',
				description:
					'Clear, concise, and conversational language to get teams where they need to go.',
				href: '/foundations/content',
				icon: 'content',
			},
			// {
			// 	title: 'Responsive design',
			// 	description: 'Displays a list of actions or options to a user.', // TODO
			// 	href: '', // TODO
			// 	icon: 'responsive-design',
			// },
			// {
			// 	title: 'Focus management',
			// 	description: 'Displays a list of actions or options to a user.', // TODO
			// 	href: '', // TODO
			// 	icon: 'focus-management',
			// },

			// {
			// 	title: 'Information architecture',
			// 	description: 'Displays a list of actions or options to a user.', // TODO
			// 	href: '', // TODO
			// 	icon: 'information-architecture',
			// },
			// {
			// 	title: 'Internationalization',
			// 	description: 'Displays a list of actions or options to a user.', // TODO
			// 	href: '', // TODO
			// 	icon: 'internationalization',
			// },
			// {
			// 	title: 'Theming',
			// 	description: 'Displays a list of actions or options to a user.', // TODO
			// 	href: '', // TODO
			// 	icon: 'theming',
			// },
		],
	},
	{
		title: 'Styles',
		cards: [
			// {
			// 	title: 'Layout',
			// 	description: 'Displays a list of actions or options to a user.', // TODO
			// 	href: '', // TODO
			// },
			{
				title: 'Spacing',
				description: 'A spacing system simplifies the creation of page layouts and UI.',
				href: '/foundations/spacing',
				icon: 'spacing',
			},
			{
				title: 'Grid',
				description: 'Grid is used to position content and create consistent page layouts.',
				href: '/foundations/grid-beta',
				icon: 'grid',
			},
			{
				title: 'Color',
				description: 'Color distinguishes our brand and reinforces experiences across apps.',
				href: '/foundations/color-new',
				icon: 'color',
			},
			{
				title: 'Typography',
				description: 'Typography is our system of fonts and text styles.',
				href: '/foundations/typography',
				icon: 'typography',
			},
			{
				title: 'Iconography',
				description: 'Icons are visual representations of commands and common actions.',
				href: '/foundations/iconography',
				icon: 'icons',
			},
			{
				title: 'Illustrations',
				description: 'Illustrations help convey complex ideas in a simple way.',
				href: '/foundations/illustrations',
				icon: 'illustration',
			},
			{
				title: 'Logos',
				description: 'Logos are the visual representation of a brand or app.',
				href: '/foundations/logos',
				icon: 'logo',
			},
			{
				title: 'Elevation',
				description: 'Elevations are layered surfaces that form the foundation of UI.',
				href: '/foundations/elevation',
				icon: 'elevation',
			},
			// {
			// 	title: 'Shape',
			// 	description: 'Displays a list of actions or options to a user.', // TODO
			// 	href: '/foundations/elevation', // TODO
			// 	icon: 'shape',
			// },
			// {
			// 	title: 'Motion',
			// 	description: 'Displays a list of actions or options to a user.',
			// 	href: '/components/motion',
			// 	icon: 'motion,
			// },
		],
	},
];

export default () => {
	return (
		<OverviewPage
			categorySlug="foundations"
			title="Foundations"
			description="Foundations create engaging user experiences. These include our tokens, guidelines, and visual styles: color, spacing, typography, and more."
			image={{
				light: heroLight,
				dark: heroDark,
			}}
			entries={data}
		>
			<ContentCardGroup data={data} />
		</OverviewPage>
	);
};
